const FETCH_LIST_REQUEST = "FETCH_LIST_REQUEST_T"
const FETCH_LIST = "FETCH_LIST_T"
const FETCH_ERROR = "FETCH_ERROR_T"
const FETCH_LIST_PASS = "FETCH_LIST_PASS_T"

const FETCH_BORROWERS_REQUEST = "FETCH_BORROWERS_REQUEST_T"
const FETCH_BORROWERS_LIST = "FETCH_LIST_T"
const FETCH_BORROWERS_PASS = "FETCH_BORROWERS_PASS_T"

const ADD_TEACHER = "ADD_TEACHER"
const ADD_TEACHER_FAIL = "ADD_TEACHER_FAIL"
const ADD_TEACHER_PASSED = "ADD_TEACHER_PASSED"

const RETURN_BOOK = "RETURN_BOOK"

const FETCH_RECORDS_REQUEST = "FETCH_RECORDS_REQUEST_TEACHER"
const FETCH_RECORDS_PASS = "FETCH_RECORDS_PASS_TEACHER"
const CLEAR_ERRORS = "CLEAR_ERRORS_T"

export {
  FETCH_LIST,
  FETCH_LIST_REQUEST,
  FETCH_LIST_PASS,
  FETCH_ERROR,
  FETCH_BORROWERS_PASS,
  FETCH_BORROWERS_LIST,
  FETCH_BORROWERS_REQUEST,
  ADD_TEACHER,
  ADD_TEACHER_FAIL,
  ADD_TEACHER_PASSED,
  RETURN_BOOK,
  FETCH_RECORDS_PASS,
  FETCH_RECORDS_REQUEST,
  CLEAR_ERRORS,
}
